var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserSetting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 0C6.984 0 0 6.984 0 15.6s6.984 15.6 15.6 15.6 15.6-6.984 15.6-15.6C31.19 6.988 24.212.01 15.6 0zm0 3.25c4.791-.012 9.155 2.754 11.19 7.091 2.034 4.338 1.372 9.461-1.7 13.138-.187.224-.5.297-.766.177-1.144-.52-2.528-1.027-4.108-1.608l-.967-.356c-.234-.17-.387-.43-.421-.718-.191-.67-.103-1.39.243-1.994 1.388-1.529 2.249-3.172 2.249-6.63.14-1.587-.406-3.158-1.499-4.317-1.092-1.16-2.628-1.797-4.221-1.751-1.593-.046-3.129.591-4.221 1.75-1.093 1.16-1.638 2.731-1.499 4.318 0 3.462.86 5.105 2.249 6.63.348.604.438 1.322.25 1.993-.035.287-.187.547-.422.718l-.967.356c-1.58.58-2.964 1.092-4.108 1.608-.266.12-.579.047-.765-.177-3.07-3.676-3.733-8.798-1.7-13.134C6.45 6.008 10.81 3.241 15.6 3.25z",
    transform: "translate(-306 -737) translate(0 711) translate(298 26) translate(8)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSetting);
export default __webpack_public_path__ + "static/media/user-setting.e6122f8f.svg";
export { ForwardRef as ReactComponent };